// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3SnUc","content":"styles_content__37Pir"};